import { Account } from 'shared/types/account';
import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';

type ThankYouHeaderProps = {
  email?: Account['email'];
  loading?: boolean;
};

const ThankYouHeader: React.FC<ThankYouHeaderProps> = ({ email, loading }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className="grid justify-items-center gap-6 border-b border-neutral-400 pb-6 pt-4 md:border-b-0 lg:justify-items-start lg:p-0">
      {/* Title */}
      <Typography
        as="h3"
        asSkeleton={loading ?? !email}
        className={`text-primary-black md:text-[18px] lg:text-[22px] ${!loading && email ? 'leading-tight' : 'leading-loose'}`}
      >
        {formatMessage({ id: 'thankyou.thanksForOrder', defaultMessage: 'Grazie per il tuo ordine' })}
      </Typography>
      {(loading || email) && (
        <Typography asSkeleton={loading} className="text-[14px] leading-loose text-secondary-black md:text-[16px]">
          {formatMessage({
            id: 'thankyou.confirmationEmail',
            defaultMessage: 'Abbiamo inviato una conferma a {email}',
            values: { email: email ?? '' },
          })}
        </Typography>
      )}
    </div>
  );
};

export default ThankYouHeader;
